import { FeedbackTag } from '@shared/feedback/menu-content/feedback-menu.data';

const toFeedbackTag = (text) => ({ text, selected: false });

export const HM_GOOD_MATCH_REASONS: FeedbackTag[] = [
  `Meets Basic Qualifications, strongest candidates`,
  `Meets Basic Qualifications, but select candidates more qualified`,
].map(toFeedbackTag);

export const HM_BAD_MATCH_REASONS_BASIC: FeedbackTag[] = [
  'Missing basic skills',
  'Overqualified',
  'Underqualified',
  'Education mismatch',
  'Recent experience mismatch',
  'Background/titles mismatch',
  'Industry mismatch',
].map(toFeedbackTag);

export const HM_BAD_MATCH_REASONS_ORACLE: FeedbackTag[] = [
  'Other candidates more qualified',
  `Doesn't meet basic qualifications`,
].map(toFeedbackTag);
